import React from 'react';
import PropTypes from 'prop-types';

import ImageWithSize from 'components/media/ImageWithSize';
import BundleUtil from 'utils/BundleUtil';
import checkeredBackgroundImage from 'images/checkered-background.png';

function ImageThumbnail(props) {
  const {
    alt,
    checkeredBackground = false,
    height,
    width,
    maxHeight,
    maxWidth,
    src,
    showBorder = true,
    style,
  } = props;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: showBorder ? '1px solid #aaaaaa' : '',
        maxHeight,
        maxWidth,
        width,
        height,
        borderRadius: 4,
        overflow: 'hidden',
        backgroundImage: checkeredBackground ? `url(${BundleUtil.getFullyQualifiedURL(checkeredBackgroundImage)})` : '',
        backgroundSize: 175,
        backgroundRepeat: 'repeat',
        ...style,
      }}
    >
      <ImageWithSize width={width} height={height} src={src} alt={alt} />
    </div>
  );
}

ImageThumbnail.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  checkeredBackground: PropTypes.bool,
  style: PropTypes.object,
};

export default ImageThumbnail;



// WEBPACK FOOTER //
// ./src/components/media/ImageThumbnail.js